import { render } from "./account-page.vue?vue&type=template&id=e4460b2e&ts=true"
import script from "./account-page.vue?vue&type=script&lang=ts"
export * from "./account-page.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__